import React, { lazy, Component, Fragment, Suspense } from "react";
import { connect } from "react-redux";
import {
  changePropertyId,
  changePropertyName,
  changeDomain,
  changeAvatarClick,
  changeBotActivation,
  changeGroupId,
  changeGroupName,
  changeLevel,
  setIsGroupButton,
  change_Integration_Channel,
  change_Chat_Started,
  changeCurrency,
  changeMode
} from "./redux/actions";
import "./MsgWindow.css";
import ChatBot from "./Component/ChatBot";
const publicIp = require("public-ip");
const Bubble = lazy(() => import("./MsgBubbleComponent/Bubble"));
const MsgWindow = lazy(() => import('./MsgWindow'));
const BFF_API_URL = process.env.REACT_APP_BFF_API_URL;
const PAGE_VISIT_URL = process.env.REACT_APP_API_URL + "/pageLoaded";
const MESSENGER_CLICKS = process.env.REACT_APP_API_URL + "/messengerclick";
const PROPERTIES_URL = process.env.REACT_APP_API_URL + "/properties-by-group";
const GROUP_URL = process.env.REACT_APP_API_URL + "/group";
const api_ADD_MESSENGER_CLICK = process.env.REACT_APP_BFF_API_URL + "/public/messenger/stats";
const BMB_INTEGRATION = process.env.REACT_APP_BFF_API_URL + "/public/integrations/helpcenter";

class MsgApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatBindings: {
        getGID: () => {
          return this.props.gid;
        },
        getIID: () => {
          return this.props.iid;
        },
        getPID: () => {
          return this.props.pid;
        },
        getAgentId: () => {
          return this.state.agentId;
        },
        getBotSettings: () => {
          return this.state.botSettings;
        },
      },
    };
    const iid = props.iid;
    const lStore = {
      OPENED: iid + "-opened",
      IDENTITY: iid + "-identity",
      LANGUAGE: iid + "-language",
      ISSHOWCHAT: iid + "-isshowchat"
    }
    this.state = {
      lStore: lStore,
      opened:
        this.props.defaultOpen ||
        (this.props.mobile == "false" &&
          localStorage.getItem(lStore.OPENED) === "open"),
      chatBindings: this.state.chatBindings,
      animation: {
        bubbleToFadeIn: true,
      },
      disabledChatbot: false,
      integrationData: null,
      botSettings: null,
      nudges: null,
      resize: false,
      properties: [],
      nudgeValue: null,
      pagePropertyId: "",
      isOpenBot: false,
      botIntegrationData: null
    };
    window.addEventListener("message", this.windowMessage.bind(this), false);
  }
  windowMessage(event) {
    //console.log(event);
    if (!this.state.opened && event.data === "msgwindowOpened") {
      this.setState({ opened: true });
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("message-nudge:")
    ) {
      let payload = JSON.parse(event.data.substr(14));
      if (payload.option === "OpenURL") {
        window.open(payload.value, "_blank");
      }
      else if (payload.option === "OpenMenuItem") {
        this.setState({ nudgeValue: payload });
        this.opened();
      }
      else if (payload.option === "SendToChatbot") {
        this.setState({ nudgeValue: payload });
        this.opened();
      }
    }
    if (typeof event.data === "string" && event.data.startsWith("chatbotConId:")) {
      var botConId = event.data.substring(13);
      if (botConId !== "") {
        this.checkConversation(botConId);
      }
    }
    // if (
    //   typeof event.data === "string" &&
    //   event.data.startsWith("update-styling:")
    // ) {
    //   let payload = event.data.substr(15);
    //   this.setState({ integrationSettings: JSON.parse(payload) });
    // }
  }
  /**
  * Posts a message to the parent window, if this window has one
  * @param {*} msg
  */
  postMessage(msg) {
    if (window.parent) {
      window.parent.postMessage(msg, "*");
    }
  }
  checkConversation(conversationId) {
    try {
      fetch(process.env.REACT_APP_API_URL + "/check-bot-start-conversation/" + conversationId + "?groupId=" + this.props.gid + "",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          if (json.result !== undefined && json.result !== null) {
            if (json.result.startedChat === true && json.result.propertyId !== null && json.result.propertyId !== this.props.propertyId) {
              this.props.changeBotActivation("false");
              this.props.change_Chat_Started("true");
            }
          }
        });
    } catch (e) { }
  }
  componentDidMount() {
    this.props.changeBotActivation("false");
    if (this.props.openChatWindow === true) {
      this.opened();
      this.postMessage("messengerwindowOpen");
    }
    this.startMessenger();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.opened !== this.state.opened) {
      this.state.opened
        ? this.postMessage("messengerwindowOpen")
        : this.postMessage("messengerwindowClose");
    }
    else {
      if (prevState.opened === true && this.state.opened === true) {
        this.postMessage("messengerwindowOpen");
      }
    }
  }
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  async startMessenger() {
    var isAllowToOpen = false;    
    var pageLinks = this.props.parent_location === undefined || this.props.parent_location === null ? "" : this.props.parent_location;
    if (pageLinks.toLowerCase().includes("myma.ai")) {
      isAllowToOpen = true;
    }
    const req = await fetch(process.env.REACT_APP_API_URL + "/check-messenger-restriction",
      {
        method: "POST",
        body: JSON.stringify({
          IntegrationId: this.props.iid,
          GroupId: this.props.gid,
          pageLinks: pageLinks
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    var result = await req.json();
    if (result && result.data && result.data.response === "allow") {
      isAllowToOpen = true;
      if (result.data.propertyId !== null) {
        this.setState({ pagePropertyId: result.data.propertyId });
      }
    }
    if (isAllowToOpen === true) {
      await this.registerPageLoad();
      setTimeout(() => {
        this.runNudges();
      }, 1000);
    }
  }
  async registerPageLoad() {
    const ip = await publicIp.v4();
    var user = {
      iid: this.props.iid,
      gid: this.props.gid,
      vid: undefined,
      sid: undefined,
      locale: "en-US",
      parent_location: this.props.parent_location,
      parent_referrer: this.props.parent_referrer,
      page_title: this.props.parent_title,
      ip: ip,
      botConversationId: "",
    };

    var identity = localStorage.getItem(this.state.lStore.IDENTITY);
    if (identity) {
      try {
        identity = JSON.parse(identity);
        user.vid = identity.vid;
        user.sid = identity.sid;
      } catch (e) {
        user.vid = undefined;
        user.sid = undefined;
      }
    }
    const req = await fetch(PAGE_VISIT_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: user,
      }),
    });
    var result = await req.json();
    if (result && result.vid && result.sid) {
      if (this.props.previewMode == "false") {
        this.setState({ disabledChatbot: result.disabled });
      }
      //   if (user.sid !== result.sid) {
      //     localStorage.removeItem(this.state.lStore.BOTCLICK);
      //   }
      //Restrict Bot based upon the IP Address
      if (result.whiteListedIpAddresses.length > 0) {
        if (result.whiteListedIpAddresses.find((x) => x === ip) === undefined) {
          this.setState({ blockChatbot: true });
        }
      }
      localStorage.setItem(this.state.lStore.IDENTITY, JSON.stringify(result));
      var localStorageLanguage = localStorage.getItem(
        this.state.lStore.LANGUAGE
      );

      var lang = "";
      var userLang = navigator.language || navigator.userLanguage;

      if (
        userLang != undefined &&
        userLang != "" &&
        result.botSettings.languages.length > 0
      ) {
        if (userLang.indexOf("-") > 0 && userLang.includes("en")) {
          //ENGLISH
          // lang = "en";
        } else if (userLang === "zh-CN") {
          //SC
          if (
            result.botSettings.languages.filter((m) => m === "zh").length > 0
          ) {
            lang = "zh";
          }
        } else if (userLang === "zh-TW") {
          //TC
          if (
            result.botSettings.languages.filter((m) => m === "zh-TW").length > 0
          ) {
            lang = "zh-TW";
          }
        } else {
          if (
            result.botSettings.languages.filter((m) => m === userLang).length >
            0
          ) {
            lang = userLang;
          }
        }
      }

      try {
        if (localStorageLanguage) {
          this.setState({
            vid: result.vid,
            sid: result.sid,
            lang: localStorageLanguage,
          });
        } else {
          this.setState({
            vid: result.vid,
            sid: result.sid,
            lang: lang === "" ? result.botSettings.defaultLanguage : lang,
          });
        }
      } catch (e) {
        this.setState({
          vid: result.vid,
          sid: result.sid,
          lang: lang === "" ? result.botSettings.defaultLanguage : lang,
        });
      }
      this.props.setIsGroupButton("false");
      this.props.change_Integration_Channel(result.channel);
      if (result.channel === "HelpCenter") {
        this.props.changeLevel("Property");
        if ((this.props.pid === "" || this.props.pid === undefined) &&
          result.level === "Group" && result.properties.length > 1) {
          const reqProperties = await fetch(PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          var resultProperties = await reqProperties.json();
          const finalResult = [];
          result.properties.forEach((p) => {
            resultProperties.properties.forEach((r) => {
              if (p === r.id) {
                finalResult.push({
                  value: r.id,
                  label: r.name,
                  displayOrder: r.displayOrder,
                  domain:
                    r.domains != undefined &&
                      r.domains.length > 0 &&
                      r.domains.filter((m) => m.priority === 1).length > 0
                      ? r.domains.filter((m) => m.priority === 1)[0].type
                      : "",
                  currency: r.currency
                });
              }
            });
          });
          const sortfinalResult = finalResult.sort(this.dynamicSort("displayOrder"));
          if (sortfinalResult.length > 0) {
            var property = this.props.propertyId;
            if (property) {
              let obj = sortfinalResult.find((o) => o.value === property);
              this.props.changePropertyId(obj === undefined ? sortfinalResult[0].value : obj.value);
            } else {
              this.props.changePropertyId(sortfinalResult[0].value);
              const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              });
              var groupData = await groupCall.json();
              if (groupData.group.domain === "") {
                this.setState({
                  pid: sortfinalResult[0].value,
                });
                this.props.changePropertyId(sortfinalResult[0].value);
                this.props.changeDomain(sortfinalResult[0].domain);
                this.props.changeCurrency({
                  propertyCurrency: sortfinalResult[0].currency,
                  groupCurrency: ""
                });
              }
            }
            try {
              var propertyName = this.props.propertName;
              if (propertyName) {
                let obj = sortfinalResult.find((o) => o.label === propertyName);
                this.props.changePropertyName(obj.label);
              } else {
                const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
                  method: "GET",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                });

                var groupData = await groupCall.json();
                //If not group level domain setup
                if (groupData.group.domain === "") {
                  this.props.changePropertyName(sortfinalResult[0].label);
                }
              }
            } catch (e) {
              const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              });

              var groupData = await groupCall.json();
              if (groupData.group.domain === "") {
                this.props.changePropertyName(sortfinalResult[0].label);
              }
            }
          }
          this.setState({ properties: sortfinalResult })
        }
        else if ((this.props.pid === "" || this.props.pid === undefined) && result.properties.length === 1) {
          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          var resultProperties = await reqProperties.json();
          result.properties.forEach((p) => {
            resultProperties.properties.forEach((r) => {
              if (p === r.id) {
                this.props.changePropertyId(r.id);
                this.props.changePropertyName(r.name);
                this.props.changeDomain(r.domains != undefined && r.domains.length > 0 &&
                  r.domains.filter((m) => m.priority === 1).length > 0
                  ? r.domains.filter((m) => m.priority === 1)[0].type
                  : ""
                );
                this.props.changeCurrency({
                  propertyCurrency: r.currency,
                  groupCurrency: ""
                });
                this.setState({ pid: r.id });
              }
            });
          });
        }
        else if (this.props.pid !== "" && this.props.pid !== undefined) {
          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );

          var resultProperties = await reqProperties.json();
          resultProperties.properties.forEach((r) => {
            if (this.props.pid === r.id) {
              this.props.changePropertyName(r.name);
              this.props.changePropertyId(r.id);
              this.props.changeDomain(r.domains != undefined && r.domains.length > 0 &&
                r.domains.filter((m) => m.priority === 1).length > 0
                ? r.domains.filter((m) => m.priority === 1)[0].type
                : ""
              );
              this.props.changeCurrency({
                propertyCurrency: r.currency,
                groupCurrency: ""
              });
              this.setState({ pid: r.id });
            }
          });
        }
      }
      else {
        const reqProperties = await fetch(PROPERTIES_URL + "/" + this.props.gid,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        var resultProperties = await reqProperties.json();
        const finalResult = [];
        result.properties.forEach((p) => {
          resultProperties.properties.forEach((r) => {
            if (p === r.id) {
              finalResult.push({
                value: r.id,
                label: r.name,
                displayOrder: r.displayOrder,
                domain:
                  r.domains != undefined &&
                    r.domains.length > 0 &&
                    r.domains.filter((m) => m.priority === 1).length > 0
                    ? r.domains.filter((m) => m.priority === 1)[0].type
                    : "",
                currency: r.currency
              });
            }
          });
        });
        const sortfinalResult = finalResult.sort(this.dynamicSort("displayOrder"));
        this.setState({
          pid: "-1", properties: sortfinalResult
        });
        const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        var groupData = await groupCall.json();
        this.props.changeGroupId(this.props.gid);
        this.props.changeGroupName(groupData.group.name);
        if (this.state.pagePropertyId !== "") {
          this.props.changeLevel("Property");
          this.props.changePropertyId(this.state.pagePropertyId);
          this.props.changeDomain("");
          var property = sortfinalResult.filter(i => i.value === this.state.pagePropertyId);
          this.props.changePropertyName(property[0].label);
          this.props.changeCurrency({
            propertyCurrency: property[0].currency,
            groupCurrency: ""
          });
        }
        else {
          this.props.changeLevel("Group");
          this.props.changePropertyId("-1");
          this.props.changeDomain("");
          this.props.changePropertyName("");
          this.props.changeCurrency({
            propertyCurrency: "",
            groupCurrency: groupData.group.currency
          });
        }
      }
    }
    //console.log(result);
    if (result.nudges) {
      //console.log(result.nudges);
      this.setState({ nudges: result.nudges });
    }
    if (result.botSettings) {
      var botId = result.botSettings.chatBot.botIntegrationId;
      if (result.botSettings.isShowChatbot === true) {
        this.props.changeMode(false);
        localStorage.setItem(this.state.lStore.ISSHOWCHAT, "true");
        if (this.state.pagePropertyId !== "") {
          await fetch(
            BMB_INTEGRATION + "/" + `${this.props.iid}?group_id=${this.props.gid}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }).then(res => res.json()).then(async (resultIntegration) => {
              if (resultIntegration.botSettings.engegedProperties !== null) {
                var engepropertyIntegrations = resultIntegration.botSettings.engegedProperties.engagedPropertyUrls;
                var webinte = engepropertyIntegrations.filter(k => k.id.includes(this.state.pagePropertyId) && k.integrationId !== null);
                if (webinte.length > 0) {
                  botId = webinte[0].integrationId;
                }
              }
            });
        }
      }
      this.setState({
        botSettings: result.botSettings,
        isOpenBot: result.botSettings.isShowChatbot,
        botIntegrationData: {
          disabled: result.botSettings.chatBot.botDisabled,
          iid: botId
        }
      });
    }
  }
  runNudges() {
    if (!this.state.nudges || this.state.opened || this.state.disabledChatbot) {
      return;
    }
    if (typeof Storage !== "undefined") {
      this.postMessage("msgX_totalnudges:" + this.state.nudges.length);
    }
    this.state.nudges.forEach((nudge) => {
      if (
        this.props.mobile === "true"
          ? !nudge.disabledInMobile
          : !nudge.disabledInDesktop
      ) {
        setTimeout(
          () => {
            if (
              nudge.eyeCatcher &&
              nudge.eyeCatcher.response &&
              nudge.eyeCatcher.response.messages
            ) {
              if (
                nudge.buttons !== null &&
                nudge.buttons !== undefined &&
                this.props.mobile == "false" &&
                nudge.buttons.length > 0
              ) {
                this.postMessage(
                  "msgXnudgebutton:" +
                  JSON.stringify({
                    text: nudge.eyeCatcher.response.messages,
                    buttons: nudge.buttons,
                    botSettings: this.state.botSettings,
                  })
                );
              } else {
                this.postMessage(
                  "msgXeyecatcher:" +
                  JSON.stringify(nudge.eyeCatcher.response.messages)
                );
              }
            }
          },
          this.props.mobile === "true"
            ? nudge.delayInMillisecondsInMobile
            : nudge.delayInMilliseconds
        );
      }
    });
  }
  opened() {
    console.log("open");
    this.setState({ opened: true, isOpenBot: localStorage.getItem(this.state.lStore.ISSHOWCHAT) === "true" ? true : false });
    this.postMessage("messengerwindowOpen");
    localStorage.setItem(this.state.lStore.OPENED, "open");
    this.recordClick();
    if (this.state.isOpenBot === true || localStorage.getItem(this.state.lStore.ISSHOWCHAT) === "true") {
      if (document.getElementById("chatbotiframe") !== null) {
        setTimeout(() => {
          document.getElementById("chatbotiframe").style.display = "block";
          document.getElementById("chatbotiframe").contentWindow.postMessage("chatwindowOpenedInMsg", "*");
        }, 1000);
      }
    }
  }
  closed() {
    if (this.state.resize === true) {
      this.setState({ resize: false });
      this.postMessage("resizeactual");
    }
    this.postMessage("messengerwindowClose");
    if (!this.props.defaultOpen) {
      this.setState({
        opened: false,
        isOpenBot: false
      });
      localStorage.removeItem(this.state.lStore.OPENED);
    }
    // this.setState({ botclick: false });
    setTimeout(() => {
      this.runNudges();
    }, 1000);
  }
  resize_full() {
    this.setState({ resize: true });
    this.postMessage("resizefull");
  }
  resize_actual() {
    this.setState({ resize: false });
    this.postMessage("resizeactual");
  }
  hintClosed() {
    this.setState({ currentNudge: undefined });
  }
  recordClick() {
    if (
      this.props.gid !== undefined &&
      this.props.iid !== undefined &&
      this.state.sid !== undefined &&
      this.props.avatarClick === "false"
    ) {
      const pid = this.props.propertyId;
      var body = {
        groupId: this.props.gid,
        integrationId: this.props.iid,
        type: 1 // stats type
      };
      if (this.props.propertyId !== "" && this.props.propertyId !== "-1" && this.props.propertyId !== undefined) {
        body = { ...body, propertyId: pid }
      }
      const req = fetch(`${api_ADD_MESSENGER_CLICK}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const reqsession = fetch(`${MESSENGER_CLICKS}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          groupId: this.props.gid,
          sessionId: this.state.sid,
          integrationId: this.props.iid,
        }),
      });
      this.props.changeAvatarClick(true);
    }
  }
  render() {
    const {
      animation,
      botSettings,
      pid,
      integrationData,
      nudges,
      opened,
      disabledChatbot
    } = this.state;
    const { iid, gid, mobile } = this.props;
    //console.log(opened, !opened,botSettings);
    return (
      <Fragment>
        {botSettings !== null && (
          <Fragment>
            {this.state.isOpenBot && this.props.botActivation === "false" && this.state.botIntegrationData !== null &&
              <ChatBot
                botIntegrationData={this.state.botIntegrationData}
                gid={gid}
                propertyId={this.props.propertyId}
                mobile={this.props.mobile}
                parent_location={this.props.parent_location}
                parent_referrer={this.props.parent_referrer}
                selectedProperty={null}
                open={false}
                isBotMode={true}
              ></ChatBot>
            }
            <div className={
              `msg_window ${mobile === "true" ? `msg_window_mobile` : `msg_window`} ${this.state.resize === true ? ` resize` : `Window`} ${!opened ? `close-messenger-pop` : `open-messenger-pop`}`}
              style={{
                visibility: opened ? "visible" : "hidden",
                borderColor: botSettings.colours !== null && botSettings.colours.frameColor !== null ?
                  botSettings.colours.frameColor : ""
              }}>
              {opened &&
                <Suspense fallback={<div></div>}>
                  <MsgWindow
                    iid={iid}
                    gid={gid}
                    closed={this.closed.bind(this)}
                    integrationData={integrationData}
                    language_state_store={this.state.lStore.LANGUAGE}
                    lang={this.state.lang}
                    mobile={this.props.mobile}
                    resize={this.state.resize}
                    resize_full={this.resize_full.bind(this)}
                    resize_actual={this.resize_actual.bind(this)}
                    properties={this.state.properties}
                    nudgeValue={this.state.nudgeValue}
                    removeNudgevalue={() => this.setState({ nudgeValue: null })}
                    parent_location={this.props.parent_location}
                    parent_referrer={this.props.parent_referrer}
                    parent_title={this.props.parent_title}
                    isautoBotopen={this.state.isOpenBot}
                  ></MsgWindow>
                </Suspense>
              }
            </div>
            {!opened && (
              <Suspense fallback={<div></div>}>
                <Bubble
                  botSettings={botSettings}
                  fadeIn={animation.bubbleToFadeIn}
                  position={this.props.position}
                  currentNudge={nudges}
                  onOpened={this.opened.bind(this)}
                  hintClosed={this.hintClosed.bind(this)}
                  mobile={mobile}
                  disabledChatbot={disabledChatbot}
                ></Bubble>
              </Suspense>
            )}
          </Fragment>)
        }
      </Fragment>
    )
  }
}
const mapStateToProps = ({ messenger }) => {
  const { botActivation, propertyId, avatarClick, groupId } = messenger;
  return { botActivation, propertyId, avatarClick, groupId };
};
export default
  connect(mapStateToProps, {
    changePropertyId,
    changePropertyName,
    changeDomain,
    changeAvatarClick,
    changeBotActivation,
    changeGroupId,
    changeGroupName,
    changeLevel,
    setIsGroupButton,
    change_Integration_Channel,
    change_Chat_Started,
    changeCurrency,
    changeMode
  })(MsgApp);